const YOUTUBE_REGEX =
  /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/;

const YOUTUBE_URL_RE =
  /https?:\/\/(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)[\w-]+(?:[?&][^\s<)}\]]*)?/gi;

export function extractYouTubeVideoId(url: string): string | null {
  return url.match(YOUTUBE_REGEX)?.[1] ?? null;
}

export function extractYouTubeFromText(text: string): { videoIds: string[]; cleaned: string } {
  const urls = text.match(YOUTUBE_URL_RE) ?? [];
  const videoIds: string[] = [];
  let cleaned = text;
  for (const url of urls) {
    const id = extractYouTubeVideoId(url);
    if (id) {
      videoIds.push(id);
      cleaned = cleaned.replace(url, '');
    }
  }
  return { videoIds, cleaned: cleaned.trim() };
}

export function getYouTubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

export function getYouTubeWatchUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}
